import axiosPrivate from "./axiosPrivate";

const getCajaCategoria = (perfil_id) => {
    return axiosPrivate.post("getCajaCategoria", {
        perfil_id
    }).then(response => response.data);
};

const insertCajaCategoria = (data) => {
    return axiosPrivate.post("insertCajaCategoria", data)
        .then(response => response.data);
};

const updateCajaCategoria = (data) => {
    return axiosPrivate.post("updateCajaCategoria", data)
        .then(response => response.data);
};

const deleteCajaCategoria = (data) => {
    return axiosPrivate.post("deleteCajaCategoria", data)
        .then(response => response.data);
};

const getCajaConcepto = (perfil_id) => {
    return axiosPrivate.post("getCajaConcepto", {
        perfil_id
    }).then(response => response.data);
};

const insertCajaConcepto = (data) => {
    return axiosPrivate.post("insertCajaConcepto", data)
        .then(response => response.data);
};

const updateCajaConcepto = (data) => {
    return axiosPrivate.post("updateCajaConcepto", data)
        .then(response => response.data);
};

const deleteCajaConcepto = (data) => {
    return axiosPrivate.post("deleteCajaConcepto", data)
        .then(response => response.data);
};

const getCajaTipoComprobante = (perfil_id) => {
    return axiosPrivate.post("getCajaTipoComprobante", {
        perfil_id
    }).then(response => response.data);
};

const insertCajaTipoComprobante = (data) => {
    return axiosPrivate.post("insertCajaTipoComprobante", data)
        .then(response => response.data);
};

const updateCajaTipoComprobante = (data) => {
    return axiosPrivate.post("updateCajaTipoComprobante", data)
        .then(response => response.data);
};

const deleteCajaTipoComprobante = (data) => {
    return axiosPrivate.post("deleteCajaTipoComprobante", data)
        .then(response => response.data);
};

const getCajaResponsable = (perfil_id) => {
    return axiosPrivate.post("getCajaResponsable", {
        perfil_id
    }).then(response => response.data);
};

const insertCajaResponsable = (data) => {
    return axiosPrivate.post("insertCajaResponsable", data)
        .then(response => response.data);
};

const updateCajaResponsable = (data) => {
    return axiosPrivate.post("updateCajaResponsable", data)
        .then(response => response.data);
};

const deleteCajaResponsable = (data) => {
    return axiosPrivate.post("deleteCajaResponsable", data)
        .then(response => response.data);
};

const getCajaCategoriaMovimiento = (perfil_id) => {
    return axiosPrivate.post("getCajaCategoriaMovimiento", {
        perfil_id
    }).then(response => response.data);
};

const insertCajaCategoriaMovimiento = (data) => {
    return axiosPrivate.post("insertCajaCategoriaMovimiento", data)
        .then(response => response.data);
};

const updateCajaCategoriaMovimiento = (data) => {
    return axiosPrivate.post("updateCajaCategoriaMovimiento", data)
        .then(response => response.data);
};

const deleteCajaCategoriaMovimiento = (data) => {
    return axiosPrivate.post("deleteCajaCategoriaMovimiento", data)
        .then(response => response.data);
};

export default {
    getCajaCategoria,
    insertCajaCategoria,
    updateCajaCategoria,
    deleteCajaCategoria,
    getCajaConcepto,
    insertCajaConcepto,
    updateCajaConcepto,
    deleteCajaConcepto,
    getCajaTipoComprobante,
    insertCajaTipoComprobante,
    updateCajaTipoComprobante,
    deleteCajaTipoComprobante,
    getCajaResponsable,
    insertCajaResponsable,
    updateCajaResponsable,
    deleteCajaResponsable,
    getCajaCategoriaMovimiento,
    insertCajaCategoriaMovimiento,
    updateCajaCategoriaMovimiento,
    deleteCajaCategoriaMovimiento
};
